


import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//FLN get api as activity type
export const getTeacherBaselineFlnThunkSkill = createAsyncThunk(
  "fln/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.quizClass}/${data.subject}/${data.program}`
    );
    return response.data;
  }
);

//PGE get api as activity type
export const getTeacherBaselinePgeThunkSkill = createAsyncThunk(
  "pge/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.quizClass}/${data.subject}`
    );
    return response.data;
  }
);

//ECE get api as activity type
export const getTeacherBaselineEceThunkSkill = createAsyncThunk(
  "ece/get",
  async (data) => {
    let response = await api.get(
      `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}/${data.quizClass}`
    );
    return response.data;
  }
);

//Community get api as activity type
// export const getTeacherBaselineCommunityThunk = createAsyncThunk(
//   "community/get",
//   async (data) => {
//     let response = await api.get(
//       `getMasterStudActSkills/${data.activityType}/${data.usertype}/${data.language}`
//     );
//     return response.data;
//   }
// );

// export const createTeacherBaselineThunk = createAsyncThunk(
//   "teacherexam/create",
//   async (body) => {
//     let response = await api.post("saveMasterStudActSkill", body);
//     return response.data;
//   }
// );

// export const updateTeacherBaselineThunk = createAsyncThunk(
//   "teacherexam/update",
//   async (reqbody) => {
//     const id = reqbody.skillId;
//     const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

//     let response = await api.put("updateMasterStudActSkill/" + id, body);
//     return response.data;
//   }
// );

export const deleteTeacherBaselineThunk = createAsyncThunk(
  "teacherexam/delete",
  async (skillId) => {
    let response = await api.delete("deleteMasterStudActSkill/" + skillId);
    return response.data;
  }
);
